import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ActivatableItem, SelectedItem, SelectedItems, SortDirection } from '../../../../activation/core/interface';
import { ActivateAppTableService } from '../activate-app-table.service';
import { ActivatableRowComponent } from './activatable-row/activatable-row.component';

@Component({
  imports: [
    AsyncPipe,
    CdkVirtualScrollViewport,
    MatIconModule,
    TranslateModule,
    NgClass,
    ActivatableRowComponent,
    CdkVirtualForOf,
    NgIf,
    CdkFixedSizeVirtualScroll,
  ],
  selector: 'app-activation-table',
  templateUrl: './activation-table.component.html',
  styleUrls: ['./activation-table.component.scss'],
  // This page is using OnPush change Detection do not remove
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivationTableComponent implements OnInit {
  private set nameSortOrder(sort: SortDirection) {
    this._nameSortOrder = sort;
    this.sortIndicator = sort === 'ASCENDING' ? 'arrow_upward' : 'arrow_downward';
  }

  private get nameSortOrder(): SortDirection {
    return this._nameSortOrder;
  }

  @Input() set activatableItems(value: ActivatableItem[]) {
    const flatItems = [];
    for (let i = 0; i < value.length; i++) {
      flatItems.push(value[i]);
      for (let j = 0; j < value[i].children.length; j++) {
        value[i].children[j].parentAppId = value[i].appId;
        flatItems.push(value[i].children[j]);
      }
    }
    this.flatItems = flatItems;
    this.scrollToTop();
  }

  @Input() hidePricing: boolean;
  @Input() removableItems?: boolean = false;
  @Input() features: any = [];

  @Output() sortChanged: EventEmitter<string> = new EventEmitter();
  @Output() itemCheckboxClicked: EventEmitter<SelectedItem> = new EventEmitter();
  @Output() itemDeleteClicked: EventEmitter<string> = new EventEmitter();

  flatItems: ActivatableItem[];

  sortIndicator = 'arrow_upward';
  selectedItems$: Observable<SelectedItems>;
  private _nameSortOrder: SortDirection = 'ASCENDING';
  partnerCurrency$: Observable<string>;

  constructor(private tableService: ActivateAppTableService) {}

  ngOnInit(): void {
    this.selectedItems$ = this.tableService.selectedItems$.pipe(shareReplay(1));
  }

  private scrollToTop(): void {
    const scrollLocation = document.querySelector('#virtual-scroll-viewport');
    if (scrollLocation) {
      scrollLocation.scrollTo(0, 0);
    }
  }

  sortItems(): void {
    if (this.nameSortOrder === 'ASCENDING') {
      this.nameSortOrder = 'DESCENDING';
    } else {
      this.nameSortOrder = 'ASCENDING';
    }
    this.sortChanged.emit(this.nameSortOrder);
  }

  // Ensure we don't unnecessaryily re-render activatable items
  uniqueActivatableItem(index: number, activatableItem: ActivatableItem): string {
    const pricing = activatableItem.pricing;
    const lenString = `${pricing && pricing.prices ? pricing.prices.length : 0}`;
    return `${activatableItem.appId}${activatableItem.name}${lenString}`;
  }

  onItemSelectionChanged(selectedItem: SelectedItem): void {
    this.itemCheckboxClicked.emit(selectedItem);
  }
}
